module.exports = __webpack_public_path__ + "img/NS-1920.d8c146e2.jpg";